import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { classActivitySettings } from '../../../../../Store/api/professor/settings';
import { CustomSelect } from '../../../../../shared/CustomSelect';
import './activity.css';
import ArrowRight from '../../../../../assets/images/Arrow-right-dark.svg';

const indicatorSeparatorStyle = {
  alignSelf: 'stretch',
  marginBottom: 8,
  marginTop: 8,
  width: 0,
};

export const IndicatorSeparator = ({ innerProps }) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};

const types = {
  perday: 'Per day',
  total: 'Total',
  none: 'None',
};

const options = [
  {
    label: 'Arabic',
    value: 'arabic',
  },
  {
    label: 'Spanish',
    value: 'spanish',
  },
  {
    label: 'French',
    value: 'french',
  },
];

const attemptsOptions = [
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
  {
    label: 'Unlimited',
    value: 'Unlimited',
  },
];

const gradesOptions = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
];

const ActivitySettings = ({
  classId,
  setClassSettingProperties,
  activitySettings = {
    dropLowestGrade: {},
    pastDuePenalty: {},
    multipleAttempts: {},
  },
}) => {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [settings, setSettings] = useState(activitySettings);

  useEffect(() => {
    setSettings(activitySettings);
  }, []);

  return (
    <div className='box_border_settings'>
      {isLoading ? (
        <div style={{ minHeight: '415px' }}>Loading...</div>
      ) : (
        <Fragment>
          <div className='settings_header'>
            <h2>activity settings</h2>
            <div className='settings_header'>
              <div className='mb-0 editt cursor d-flex align-items-center'>
                <p
                  className={`text-uppercase mb-0 ${isEditing ? 'text-decoration-none' : ''}`}
                  onClick={() => {
                    setIsEditing(true);
                  }}
                >
                  {isEditing ? 'editing' : 'edit'}
                </p>
              </div>
            </div>
          </div>
          <div className='activity_setting_row'>
            <p>Allow feedback from students</p>
            <div className='right_buttons'>
              <div className='btn_wrapper'>
                {isEditing ? (
                  <Fragment>
                    <label
                      for='yes'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return { ...old, allowStdFeedback: true };
                        });
                      }}
                    >
                      Yes
                      <input type='radio' name='noti' id='yes' checked={settings.allowStdFeedback} value={'yes'} className='custome_radio cursor' />
                      <span></span>
                    </label>
                    <label
                      for='no'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return { ...old, allowStdFeedback: false };
                        });
                      }}
                    >
                      No
                      <input type='radio' name='noti' checked={!settings.allowStdFeedback} id='no' value={'yes'} className='custome_radio cursor' />
                      <span></span>
                    </label>
                  </Fragment>
                ) : (
                  <div className='btn_el'>{activitySettings.allowStdFeedback ? 'Yes' : 'No'}</div>
                )}
              </div>
            </div>
          </div>
          <div className='activity_setting_row'>
            <p>Allow multiple attempts</p>
            <div className='right_buttons'>
              <div className='btn_wrapper'>
                {isEditing ? (
                  <Fragment>
                    <CustomSelect
                      className='w-40'
                      options={attemptsOptions}
                      value={attemptsOptions.filter((item) => item.label === `${settings.multipleAttempts.count}`)?.[0]}
                      handleChange={(event) => {
                        setSettings((prev) => ({
                          ...prev,
                          multipleAttempts: {
                            ...prev.multipleAttempts,
                            count: event.label,
                          },
                        }));
                      }}
                      components={{ IndicatorSeparator }}
                    />
                    <label
                      for='allowyes'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return {
                            ...old,
                            multipleAttempts: {
                              ...old.multipleAttempts,
                              isAllowed: true,
                            },
                          };
                        });
                      }}
                    >
                      Yes
                      <input type='radio' name='allowattempts' id='allowyes' value={'yes'} checked={settings.multipleAttempts.isAllowed} className='custome_radio cursor' />
                      <span></span>
                    </label>
                    <label
                      for='allowno'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return {
                            ...old,
                            multipleAttempts: {
                              ...old.multipleAttempts,
                              isAllowed: false,
                            },
                          };
                        });
                      }}
                    >
                      No
                      <input type='radio' name='allowattempts' id='allowno' value={'no'} checked={!settings.multipleAttempts.isAllowed} className='custome_radio cursor' />
                      <span></span>
                    </label>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className='btn_el'>{activitySettings.multipleAttempts ? activitySettings.multipleAttempts.count : 0}</div>
                    <div className='btn_el'>{activitySettings.multipleAttempts && activitySettings.multipleAttempts.isAllowed ? 'Yes' : 'No'}</div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <div className='activity_setting_row'>
            <p>Drop lowest grade per chapter</p>
            <div className='right_buttons'>
              <div className='btn_wrapper'>
                {isEditing ? (
                  <Fragment>
                    <CustomSelect
                      className='w-25'
                      options={gradesOptions}
                      value={gradesOptions.filter((item) => item.label === `${settings.dropLowestGrade.percentage}`)}
                      handleChange={(event) => {
                        setSettings((prev) => ({
                          ...prev,
                          dropLowestGrade: {
                            ...prev.dropLowestGrade,
                            percentage: event.label,
                          },
                        }));
                      }}
                      components={{ IndicatorSeparator }}
                    />
                    <label
                      for='dropgradeyes'
                      className='btn_el'
                      onClick={(e) => {
                        setSettings((old) => {
                          return {
                            ...old,
                            dropLowestGrade: {
                              ...(old.dropLowestGrade || {}),
                              status: true,
                            },
                          };
                        });
                      }}
                    >
                      Yes
                      <input type='radio' name='dropgrade' id='dropgradeyes' value={'yes'} checked={settings.dropLowestGrade ? settings.dropLowestGrade.status : false} className='custome_radio cursor' />
                      <span></span>
                    </label>
                    <label
                      for='dropgradeno'
                      className='btn_el'
                      onClick={(e) => {
                        setSettings((old) => {
                          return {
                            ...old,
                            dropLowestGrade: {
                              ...(old.dropLowestGrade || {}),
                              status: false,
                            },
                          };
                        });
                      }}
                    >
                      No
                      <input type='radio' name='dropgrade' id='dropgradeno' value={'no'} checked={settings.dropLowestGrade ? !settings.dropLowestGrade.status : true} className='custome_radio cursor' />
                      <span></span>
                    </label>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className='btn_el'>{activitySettings.dropLowestGrade.percentage}</div>
                    <div className='btn_el'>{activitySettings.dropLowestGrade.status ? 'Yes' : 'No'}</div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <div className='activity_setting_row'>
            <p>Can submit past due date</p>
            <div className='right_buttons'>
              <div className='btn_wrapper'>
                {isEditing ? (
                  <Fragment>
                    <label
                      for='pastdueyes'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return { ...old, isPastDueAllowed: true };
                        });
                      }}
                    >
                      Yes
                      <input type='radio' name='pastdue' id='pastdueyes' value={'yes'} checked={settings.isPastDueAllowed} className='custome_radio cursor' />
                      <span></span>
                    </label>
                    <label
                      for='pastdueno'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return { ...old, isPastDueAllowed: false };
                        });
                      }}
                    >
                      No
                      <input type='radio' name='pastdue' id='pastdueno' value={'no'} checked={!settings.isPastDueAllowed} className='custome_radio cursor' />
                      <span></span>
                    </label>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className='btn_el'>{'Yes'}</div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <div className='activity_setting_row'>
            <p>Past due date penalty</p>
            <div className='right_buttons'>
              <div className='btn_wrapper'>
                {isEditing ? (
                  <Fragment>
                    {' '}
                    <input
                      type='number'
                      className='number_input btn_el'
                      name='some'
                      value={settings.pastDuePenalty && settings.pastDuePenalty.percentage ? settings.pastDuePenalty.percentage : 0}
                      onChange={(e) => {
                        setSettings((old) => {
                          return {
                            ...old,
                            pastDuePenalty: {
                              ...(old.pastDuePenalty || {}),
                              percentage: e.target.value,
                            },
                          };
                        });
                      }}
                    />
                    <label
                      for='panaltyperday'
                      className='btn_el'
                      onClick={(e) => {
                        setSettings((old) => {
                          return {
                            ...old,
                            pastDuePenalty: {
                              ...(old.pastDuePenalty || {}),
                              type: 'perday',
                            },
                          };
                        });
                      }}
                    >
                      Per day
                      <input type='radio' name='panalty' id='panaltyperday' value={'perday'} checked={settings.pastDuePenalty && settings.pastDuePenalty.type === 'perday'} className='custome_radio cursor' />
                      <span></span>
                    </label>
                    <label
                      for='panaltytotal'
                      className='btn_el'
                      onClick={(e) => {
                        setSettings((old) => {
                          return {
                            ...old,
                            pastDuePenalty: {
                              ...(old.pastDuePenalty || {}),
                              type: 'total',
                            },
                          };
                        });
                      }}
                    >
                      Total
                      <input type='radio' name='panalty' id='panaltytotal' value={'total'} checked={settings.pastDuePenalty && settings.pastDuePenalty.type === 'total'} className='custome_radio cursor' />
                      <span></span>
                    </label>
                    <label
                      for='panaltynone'
                      className='btn_el'
                      onClick={(e) => {
                        setSettings((old) => {
                          return {
                            ...old,
                            pastDuePenalty: {
                              ...(old.pastDuePenalty || {}),
                              type: 'none',
                            },
                          };
                        });
                      }}
                    >
                      None
                      <input type='radio' name='panalty' id='panaltynone' value={'none'} checked={settings.pastDuePenalty && settings.pastDuePenalty.type === 'none'} className='custome_radio cursor' />
                      <span></span>
                    </label>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className='btn_el'>{types[settings.pastDuePenalty.type] || 'None'}</div>
                    <div className='btn_el'>{settings.pastDuePenalty.percentage} %</div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <div className='activity_setting_row'>
            <p>Special characters provided</p>
            <div className='right_buttons'>
              <div className='btn_wrapper'>
                {isEditing ? (
                  <div style={{ width: '200px' }}>
                    <CustomSelect
                      className='w-100'
                      options={options}
                      value={options.filter((item) => item.label === settings.spacialChars)?.[0]}
                      handleChange={(event) => {
                        setSettings((prev) => ({
                          ...prev,
                          spacialChars: event.value,
                        }));
                      }}
                      components={{ IndicatorSeparator }}
                    />
                  </div>
                ) : (
                  <Fragment>
                    <div className='btn_el'>{settings.spacialChars || '--'}</div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <div className='activity_setting_row'>
            <p>Auto-grade accounts for accent marks</p>
            <div className='right_buttons'>
              <div className='btn_wrapper'>
                {isEditing ? (
                  <Fragment>
                    {' '}
                    <label
                      for='autoyes'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return { ...old, autoGradeAccent: true };
                        });
                      }}
                    >
                      Yes
                      <input type='radio' name='auto' id='autoyes' value={'yes'} checked={settings.autoGradeAccent} className='custome_radio cursor' />
                      <span></span>
                    </label>
                    <label
                      for='autono'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return { ...old, autoGradeAccent: false };
                        });
                      }}
                    >
                      No
                      <input type='radio' name='auto' id='autono' checked={!settings.autoGradeAccent} value={'no'} className='custome_radio cursor' />
                      <span></span>
                    </label>
                  </Fragment>
                ) : (
                  <div className='btn_el'>{activitySettings.autoGradeAccent ? 'Yes' : 'No'}</div>
                )}
              </div>
            </div>
          </div>
          <div className='activity_setting_row'>
            <p>Auto-grade accounts for capitalization</p>
            <div className='right_buttons'>
              <div className='btn_wrapper'>
                {isEditing ? (
                  <Fragment>
                    {' '}
                    <label
                      for='capsyes'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return { ...old, autoGradeCapitalization: true };
                        });
                      }}
                    >
                      Yes
                      <input type='radio' name='caps' id='capsyes' value={'yes'} checked={settings.autoGradeCapitalization} className='custome_radio cursor' />
                      <span></span>
                    </label>
                    <label
                      for='capsno'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return { ...old, autoGradeCapitalization: false };
                        });
                      }}
                    >
                      No
                      <input type='radio' name='caps' id='capsno' checked={!settings.autoGradeCapitalization} value={'no'} className='custome_radio cursor' />
                      <span></span>
                    </label>
                  </Fragment>
                ) : (
                  <div className='btn_el'>{activitySettings.autoGradeCapitalization ? 'Yes' : 'No'}</div>
                )}
              </div>
            </div>
          </div>
          <div className='activity_setting_row'>
            <p>Auto-grade accounts for punctuation</p>
            <div className='right_buttons'>
              <div className='btn_wrapper'>
                {isEditing ? (
                  <Fragment>
                    {' '}
                    <label
                      for='punctsyes'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return { ...old, autoGradePunctuation: true };
                        });
                      }}
                    >
                      Yes
                      <input type='radio' name='puncts' id='punctsyes' value={'yes'} checked={settings.autoGradePunctuation} className='custome_radio cursor' />
                      <span></span>
                    </label>
                    <label
                      for='punctsno'
                      className='btn_el'
                      onClick={() => {
                        setSettings((old) => {
                          return { ...old, autoGradePunctuation: false };
                        });
                      }}
                    >
                      No
                      <input type='radio' name='puncts' id='punctsno' value={'no'} checked={!settings.autoGradePunctuation} className='custome_radio cursor' />
                      <span></span>
                    </label>
                  </Fragment>
                ) : (
                  <div className='btn_el'>{activitySettings.autoGradePunctuation ? 'Yes' : 'No'}</div>
                )}
              </div>
            </div>
          </div>
          <div className='activity_setting_row' style={{ marginBottom: '0px', marginTop: '16px' }}>
            <p></p>
            <div className='right_buttons'>
              <div className='btn_wrapper'>
                {isEditing && (
                  <div
                    style={{ fontSize: 14, fontWeight: 500 }}
                    className='btn_el cursor'
                    onClick={() => {
                      setIsLoading(true);
                      dispatch(
                        classActivitySettings({
                          id: classId,
                          body: settings,
                          onSuccess: (res) => {
                            setClassSettingProperties('activitySettings', settings);
                            setIsLoading(false);
                            setIsEditing(false);
                          },
                          onError: (error) => {
                            setIsLoading(false);
                            if (error.response && error.response.data.message) {
                              window.alert(error.response.data.message);
                            } else {
                              window.alert('Unknown error!!!');
                            }
                          },
                        })
                      );
                    }}
                  >
                    Save <img src={ArrowRight} alt='save' />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default ActivitySettings;
